import { css } from '@emotion/react';

import { colors } from '../../global';

export const ButtonBoxedGhost = css`
    text-decoration: none;

    &.pengestyrke {
        background-color: ${colors.elephant};
        border: 3px solid ${colors.white};
        color: ${colors.white};

        &:hover {
            text-decoration: underline;
            background-color: ${colors.white};
            color: ${colors.elephant};
        }
    }
`;
